import React, { Component } from 'react'
import {
  evolve,
  reject,
  propEq
} from 'ramda'
import { Button, Div, NavigationHeader } from '@driftt/tide-core'

import { getAllSegments } from 'api/segments'
import Segments from 'components/Segments'

import './style.css'

class AccountsSegmentation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      segments: null,
      isLoading: true
    }
  }

  componentDidMount() {
    this.getSegments()
  }

  handleDeleteSegment = segmentId => {
    const removeDeletedSegment = evolve({
      segments: reject(propEq('id', segmentId))
    })

    this.setState(prevState => ({
      segments: removeDeletedSegment(prevState.segments)
    }))
  }

  getSegments = async (options) => {
    const currentIndex = (options && options.index) || 0
    const currentSize = (options && options.size) || 25
    const nameFilter = (options && options.nameFilter) || ''

    try {
      const { data } = await getAllSegments({
        index: currentIndex,
        size: currentSize,
        name: nameFilter
      })
      this.setState({
        segments: data,
        isLoading: false
      })
    } catch (e) {
      console.log(e)
    }
  }

  render() {
    const { segments, isLoading } = this.state
    const { onSegmentSelect, history } = this.props
    const accountsRoot = '/'

    return (
      <Div className="segmentation-home-container">
        <NavigationHeader title="Account segments">
          <Button onClick={() => history.push(accountsRoot + '?createSegment=true')}>
            Create segment
          </Button>
        </NavigationHeader>
        <Segments 
          data={segments}
          isLoading={isLoading}
          onSegmentSelect={onSegmentSelect}
          onDeleteSegment={this.handleDeleteSegment}
          getSegments={this.getSegments}
        />
      </Div>
    )
  }
}

export default AccountsSegmentation
